// extracted by mini-css-extract-plugin
export default {"wrapper":"ez-z","viewport":"fz-z","container":"gz-z","slide":"hz-z"};